// import React from "react";
// import { motion } from "framer-motion";
// import { useTranslation } from 'react-i18next';
// import gil from "../asset/trustBy/gils.png";
// import united from "../asset/trustBy/united2.png";
// import rangechem from "../asset/trustBy/rangechems.png";
// import hico from "../asset/trustBy/hico.png";
// import taar from "../asset/trustBy/taar1.png";
// import redflag from "../asset/trustBy/redflag1.png";
// import logo from "../asset/trustBy/logo.png";

// const TrustedBy = () => {
//   const { t } = useTranslation();

//   const logos = [
//     { imgSrc: gil, altText: "Gil" },
//     { imgSrc: united, altText: "United" },
//     { imgSrc: rangechem, altText: "Rangechem" },
//     { imgSrc: hico, altText: "Hico" },
//     { imgSrc: taar, altText: "Taar" },
//     { imgSrc: redflag, altText: "Redflag" },
//     { imgSrc: logo, altText: "Logo" },
//   ];

//   // Double the list for infinite looping marquee
//   const marqueeLogos = [...logos, ...logos];

//   return (
//     <section className="py-12 md:py-16 bg-slate-50/50 dark:bg-neutral-900/10 border-y border-slate-200/50 dark:border-neutral-800/40 transition-colors duration-500 overflow-hidden">
//       <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10 text-center">
//         <motion.h3
//           initial={{ opacity: 0, y: 15 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="text-lg font-bold text-slate-400 dark:text-neutral-500 uppercase tracking-widest"
//         >
//           {t('trustedByTitle')}
//         </motion.h3>
//         <motion.p
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ delay: 0.1 }}
//           className="text-xs text-slate-500 dark:text-neutral-500 mt-2 max-w-md mx-auto"
//         >
//           {t('trustedByDescription')}
//         </motion.p>
//       </div>

//       {/* Infinite Marquee Container */}
//       <div className="relative w-full flex items-center overflow-hidden py-4">
//         {/* Soft edge blur shadows */}
//         <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent dark:from-[#080808] z-10 pointer-events-none" />
//         <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent dark:from-[#080808] z-10 pointer-events-none" />

//         <motion.div
//           animate={{ x: ["0%", "-50%"] }}
//           transition={{
//             ease: "linear",
//             duration: 25,
//             repeat: Infinity,
//           }}
//           className="flex items-center gap-16 min-w-max px-8"
//         >
//           {marqueeLogos.map((logo, index) => (
//             <div
//               key={index}
//               className="flex items-center justify-center h-16 w-36 px-4 bg-slate-50/50 dark:bg-neutral-900/20 rounded-2xl border border-slate-100 dark:border-neutral-800/40 backdrop-blur-sm grayscale opacity-60 hover:grayscale-0 hover:opacity-100 dark:hover:opacity-100 transition-all duration-300"
//             >
//               <img
//                 src={logo.imgSrc}
//                 alt={logo.altText}
//                 className="max-h-8 max-w-full object-contain filter dark:brightness-200 dark:contrast-100 dark:invert-0"
//               />
//             </div>
//           ))}
//         </motion.div>
//       </div>
//     </section>
//   );
// };

// export default TrustedBy;


import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import gil from "../asset/trustBy/gils.png";
import united from "../asset/trustBy/united2.png";
import rangechem from "../asset/trustBy/rangechems.png";
import hico from "../asset/trustBy/hico.png";
import taar from "../asset/trustBy/taar1.png";
import redflag from "../asset/trustBy/redflag1.png";
import logo from "../asset/trustBy/logo.png";

const TrustedBy = () => {
  const { t } = useTranslation();

  const logos = [
    { imgSrc: gil, altText: "Gil" },
    { imgSrc: united, altText: "United" },
    { imgSrc: rangechem, altText: "Rangechem" },
    { imgSrc: hico, altText: "Hico" },
    { imgSrc: taar, altText: "Taar" },
    { imgSrc: redflag, altText: "Redflag" },
    { imgSrc: logo, altText: "Logo" },
  ];

  const marqueeLogos = [...logos, ...logos];

  return (
    <section className="py-14 md:py-20 bg-white dark:bg-[#080808] border-y border-slate-200 dark:border-neutral-800 transition-colors duration-500 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-10 text-center">
        <motion.h3
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-xl md:text-2xl font-extrabold text-slate-700 dark:text-neutral-300 uppercase tracking-[0.25em]"
        >
          {t("trustedByTitle")}
        </motion.h3>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-sm text-slate-600 dark:text-neutral-400 mt-3 max-w-xl mx-auto leading-relaxed"
        >
          {t("trustedByDescription")}
        </motion.p>
      </div>

      <div className="relative w-full flex items-center overflow-hidden py-6">
        <div className="absolute left-0 top-0 bottom-0 w-28 bg-gradient-to-r from-white to-transparent dark:from-[#080808] z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-28 bg-gradient-to-l from-white to-transparent dark:from-[#080808] z-10 pointer-events-none" />

        <motion.div
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            ease: "linear",
            duration: 25,
            repeat: Infinity,
          }}
          className="flex items-center gap-10 md:gap-14 min-w-max px-8"
        >
          {marqueeLogos.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-center h-20 w-44 px-6 bg-white dark:bg-neutral-900/70 rounded-2xl border border-slate-200 dark:border-neutral-800 shadow-sm hover:shadow-md transition-all duration-300"
            >
        <img
  src={item.imgSrc}
  alt={item.altText}
  className="
    max-h-10 max-w-full object-contain
    opacity-70 hover:opacity-100
    filter brightness-0
    dark:brightness-0 dark:invert
    transition-all duration-300
  "
/>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustedBy;